import React, { useEffect, useState, useRef } from "react";
import { Pagination, Table, Button, Modal } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import pdfImg from "../Assets/images/pdfImg.png";
import { PDFDocument, StandardFonts, rgb, PDFName, PDFArray } from "pdf-lib";
import { saveAs } from "file-saver";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import JSZip from "jszip";
import Logo from "../Assets/images/fav-icon.png";
import axios from "axios";
import { API_BASE_URL } from "../../global";

// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

// import { Document, Page } from 'react-pdf';
// import { pdfjs } from 'react-pdf';

const ITEMS_PER_PAGE = 5;

const DuplicatereportHeaders = [
    { label: "Page Number", key: "page_number" },
    { label: "Duplicate Page", key: "duplicate_page" },
    { label: "Similarity", key: "similarity" },
];

const MissingreportHeaders = [
    { label: "Before Page", key: "before_page" },
    { label: "After Page", key: "after_page" },
    { label: "Reason", key: "reason" },
];




const PDFCanvasViewerbkp = ({
    fileUrl,
    pageRange = "1",
    scale = 1.5,
    selectedpdf,
}) => {
    const containerRef = useRef();
    const [zoom, setZoom] = useState(scale);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        let cancelled = false;
        const renderPages = async () => {
            // if (!fileUrl) return;
            if (!selectedpdf || !containerRef.current) return;
            if (cancelled || !containerRef.current) return;

            setLoading(true);
            const container = containerRef.current;
            container.innerHTML = "";

            let pages = [];
            if (typeof pageRange === "string" && pageRange.includes("-")) {
                const [start, end] = pageRange.split("-").map(Number);
                pages = Array.from({ length: end - start + 1 }, (_, i) => start + i);
            } else {
                const num = parseInt(pageRange, 10);
                if (!isNaN(num)) pages = [num];
            }

            for (const pageNum of pages) {
                if (pageNum < 1 || pageNum > selectedpdf.numPages) continue;

                const page = await selectedpdf.getPage(pageNum);
                const viewport = page.getViewport({ scale: zoom });

                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = viewport.width;
                canvas.height = viewport.height;
                canvas.marginBottom = "10px";

                await page.render({ canvasContext: ctx, viewport }).promise;

                // if (!cancelled) container.appendChild(canvas);
                if (!cancelled) {
                    // Create page number element
                    const pageNumberDiv = document.createElement("div");
                    pageNumberDiv.style.textAlign = "center";
                    pageNumberDiv.style.marginTop = "0px";
                    pageNumberDiv.style.marginBottom = "0px";
                    pageNumberDiv.innerHTML = `Page ${pageNum} of ${selectedpdf.numPages}`;
                    container.appendChild(pageNumberDiv);
                    container.appendChild(canvas);
                }
            }
            setLoading(false);
        };
        renderPages();

        return () => {
            cancelled = true;
        };
    }, [selectedpdf, pageRange, zoom]);

    return (
        <div style={{ position: "relative", height: "100%" }}>
            {loading && (
                <div className="pdfloader-container">
                    <div style={{ textAlign: "center", fontSize: "18px", color: "#555" }}>
                        Loading PDF...
                    </div>
                    <div className="pdfloader"></div>
                </div>
            )}

            <div
                ref={containerRef}
                style={{ display: "flex", flexDirection: "column", gap: "5px" }}
            />
        </div>
    );
};

const PDFCanvasViewer = ({
    pageRange = "1",
    scale = 1.5,
    selectedpdf,

}) => {
    const caseId = localStorage.getItem("caseID");
    const containerRef = useRef();
    const [zoom, setZoom] = useState(scale);
    const [loading, setLoading] = useState(true);
    const [pdfPages, setPdfPages] = useState([]);
    console.log(pageRange, caseId)
    useEffect(() => {
        if (!caseId) return;

        const parsePageRange = () => {
            if (typeof pageRange === 'string' && pageRange.includes('-')) {
                const [start, end] = pageRange.split('-').map(Number);
                if (start && end && start <= end) {
                    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
                }
            }

            const num = parseInt(pageRange, 10);
            if (!isNaN(num)) return [num];

            return [];
        };

        const pagesToFetch = parsePageRange();
        if (pagesToFetch.length === 0) return;

        const fetchPages = async () => {
            setLoading(true);
            try {
                const response = await axios.post(
                    `${API_BASE_URL}get_pages`,
                    {
                        case_id: caseId,
                        pages: pagesToFetch,
                    }
                );

                if (response.data.status === 1) {
                    setPdfPages(response.data.pdf_pages);
                } else {
                    console.error('API error:', response.data.message);
                    setPdfPages([]);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setPdfPages([]);
            }
        };

        fetchPages();
    }, [caseId, pageRange]);

    // Render PDF pages whenever pdfPages or zoom changes
    useEffect(() => {
        let cancelled = false;

        const renderPages = async () => {
            if (!pdfPages.length) return;
            const container = containerRef.current;
            if (!container) return;

            container.innerHTML = ''; // Clear previous content

            for (const pageData of pdfPages) {
                const { page_url, page_no } = pageData;

                try {
                    const loadingTask = pdfjsLib.getDocument({
                        url: page_url,
                        withCredentials: false,
                    });

                    const pdf = await loadingTask.promise;
                    const page = await pdf.getPage(1);
                    const viewport = page.getViewport({ scale: zoom });

                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    canvas.width = viewport.width;
                    canvas.height = viewport.height;

                    await page.render({ canvasContext: ctx, viewport }).promise;

                    if (cancelled) return;

                    container.appendChild(canvas);

                    const pageNumberDiv = document.createElement('div');
                    pageNumberDiv.style.textAlign = 'center';
                    pageNumberDiv.style.marginTop = '8px';
                    pageNumberDiv.innerHTML = `Page ${page_no}`;
                    container.appendChild(pageNumberDiv);
                    setLoading(false);

                } catch (error) {
                    console.error(`Error rendering page ${pageData.page_no}:`, error);
                }
            }
        };

        renderPages();

        return () => {
            cancelled = true;
        };
    }, [pdfPages, zoom]);
    return (
        <div style={{ position: "relative", height: "100%" }}>
            {loading && (
                <div className="pdfloader-container">
                    <div style={{ textAlign: "center", fontSize: "18px", color: "#555" }}>
                        Loading PDF...
                    </div>
                    <div className="pdfloader"></div>
                </div>
            )}

            <div
                ref={containerRef}
                style={{ display: "flex", flexDirection: "column", gap: "5px" }}
            />
        </div>
    );
};


const MissingorDuplicateReport = ({
    handlemissingdataclick,
    AISelectedApp,
    selectedpdf,
}) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [reportData, setreportData] = useState([]);
    const [reportType, setreportType] = useState(null);

    const [headers, setHeaders] = useState([]);
    const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
    const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
    const currentItems = reportData.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(reportData.length / ITEMS_PER_PAGE);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const fastBackward = () => setCurrentPage(1);
    const fastForward = () => setCurrentPage(totalPages);

    console.log(AISelectedApp, selectedpdf);
    const [pdfToPreview, setPdftopreview] = useState(null);
    const [pdfBytesPreview, setPdfBytesPreview] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedItem, setselectedItem] = useState(null);
    const [pageRange, setPageRange] = useState("1");

    const [pdfProgress, setPdfProgress] = useState({
        percent: 0,
        status: "idle",
    });


    const [scale, setScale] = useState(1.0);

    const handleZoomIn = () => setScale(scale => Math.min(scale + 0.2, 4.0)); // Limit max zoom
    const handleZoomOut = () => setScale(scale => Math.max(scale - 0.2, 0.5)); // Limit min zoom


    //   const [PdfLoading, setPdfLoading] = useState(false);

    useEffect(() => {
        let cancelled = false;
        const loadPdf = async () => {
            if (!selectedpdf) return;
            // const response = await fetch(selectedpdf);
            // const arrayBuffer = await response.arrayBuffer();
            // setPdfBytesPreview(arrayBuffer);
            const bytes = await fetch(selectedpdf).then(res => res.arrayBuffer());
            if (!cancelled) {
                const loadingTask = pdfjsLib.getDocument({ data: bytes });

                const loadedPdf = await loadingTask.promise;
                if (!cancelled) setPdftopreview(loadedPdf);
            }
        };

        loadPdf();
        return () => {
            cancelled = true;
        };
    }, [selectedpdf]);

    const pageNumbers = [];

    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }

    const determineHeaderSet = (items) => {
        // if (!items || items.length === 0) return [];

        // const firstItem = items;
        // const hasKeys = (keys) => keys.every((key) => key in firstItem);
        // console.log(firstItem);
        console.log(AISelectedApp?.summaryPmtLabel);
        // if (hasKeys(["duplicate_page"])) {
        //     setreportType("Duplicate");
        //     return DuplicatereportHeaders;
        // } else if (hasKeys(["before_page"])) {
        //     setreportType("Missing");
        //     return MissingreportHeaders;
        // }
        if (AISelectedApp?.summaryPmtLabel === "Duplicate Data") {
            setreportType("Duplicate");
            return DuplicatereportHeaders;
        } else if (AISelectedApp?.summaryPmtLabel === "Missing Data") {
            setreportType("Missing");
            return MissingreportHeaders;
        }

        return [];
    };

    useEffect(() => {
        let agentData = AISelectedApp?.agentData || [];

        if (typeof agentData === "string") { 
            try {
                agentData = JSON.parse(agentData);
                if (
                    typeof agentData === "string" &&
                    /<\/?[a-z][\s\S]*>/i.test(agentData)
                ) {
                    agentData = [];
                }
            } catch (error) {
                agentData = [];
            }
        }

        // Ensure only arrays are set
        if (!Array.isArray(agentData)) {
            agentData = [];
        }

        setreportData(agentData);
        setHeaders(determineHeaderSet(agentData[0]));
    }, [AISelectedApp]);

    const handleViewClick = (item) => {
        console.log(item);
        if (reportType === "Duplicate") {
            setselectedItem(item);
            const pageRange1 = parseInt(item.page_number, 10);
            const pageRange2 = parseInt(item.duplicate_page, 10);
            setPageRange({ pageRange1, pageRange2 });
            setShowModal(true);
        } else if (reportType === "Missing") {
            const pageRange = `${item.before_page}-${item.after_page}`;
            handlemissingdataclick(pageRange);
        }
    };

    function splitTextToLines(text, font, fontSize, maxWidth) {
        const words = text.split(" ");
        const lines = [];
        let currentLine = "";

        words.forEach((word) => {
            const testLine = currentLine ? currentLine + " " + word : word;
            const width = font.widthOfTextAtSize(testLine, fontSize);
            if (width > maxWidth) {
                if (currentLine) lines.push(currentLine);
                currentLine = word;
            } else {
                currentLine = testLine;
            }
        });

        if (currentLine) lines.push(currentLine);
        return lines;
    }

    // ✅ Function to add a clickable link to a page
    function addPageLink(pdfDoc, page, x, y, width, height, targetPageIndex) {
        let Annots = page.node.get(PDFName.of("Annots"));

        if (!Annots) {
            Annots = pdfDoc.context.obj([]);
            page.node.set(PDFName.of("Annots"), Annots);
        } else {
            Annots = pdfDoc.context.lookup(Annots);

            if (!(Annots instanceof PDFArray)) {
                const arr = pdfDoc.context.obj([Annots]);
                page.node.set(PDFName.of("Annots"), arr);
                Annots = arr;
            }
        }

        const newLink = pdfDoc.context.obj({
            Type: "Annot",
            Subtype: "Link",
            Rect: [x, y, x + width, y + height],
            Border: [0, 0, 0],
            Dest: [pdfDoc.getPage(targetPageIndex).ref, PDFName.of("Fit")],
        });

        // console.log("Link ", newLink);

        Annots.push(newLink);
    }



    function removeDuplicatesKeepOrder(arr) {
        const seen = new Set();
        return arr.filter((x) => {
            if (seen.has(x)) return false;
            seen.add(x);
            return true;
        });
    }

    // Main PDF generation function

    function addWatermark(page, text, font, pageWidth, pageHeight) {
        const fontSize = 60;
        // const textWidth = font.widthOfTextAtSize(text, fontSize);
        const textWidth = font.widthOfTextAtSize(text, fontSize);
        const textHeight = fontSize; // approx line height

        // Center coordinates
        const centerX = pageWidth / 2 - textWidth / 2 + 50;
        const centerY = pageHeight / 2 - textHeight / 2;

        page.drawText(text, {
            x: centerX,
            y: centerY,
            size: fontSize,
            font,
            color: rgb(0.8, 0.8, 0.8), // light gray
            rotate: { type: "degrees", angle: 45 },
            opacity: 0.2,
        });
    }
    async function addLogo(page, pdfDoc, logoBytes, pageWidth, logoWidth = 50, logoHeight = 40) {
        const logoImage = await pdfDoc.embedPng(logoBytes);

        const x = pageWidth - logoWidth - 20; // right margin
        const y = page.getHeight() - logoHeight - 10; // top margin

        page.drawImage(logoImage, {
            x,
            y,
            width: logoWidth,
            height: logoHeight,
        });
    }

    function randomPrefix() {
        return Math.floor(100 + Math.random() * 900); // 3-digit number between 100 and 999
    }

    const downloadPDF = async () => {
        try {
            const id = localStorage.getItem("caseID");
            const now = new Date();
            const pad = (n) => String(n).padStart(2, "0");

            setPdfProgress({ percent: 5, status: "loading" });
            // console.log("pdfBytesPreview", pdfBytesPreview)
            // if (!pdfBytesPreview) return; // use the stored ArrayBuffer

            // const existingPdf = await PDFDocument.load(pdfBytesPreview);
            const existingPdfBytes = await fetch(selectedpdf).then((res) => res.arrayBuffer());
            const existingPdf = await PDFDocument.load(existingPdfBytes);


            setPdfProgress({ percent: 15, status: "loading" });

            // const existingPdf = await PDFDocument.load(existingPdfBytes);
            const pdfDoc = await PDFDocument.create();
            setPdfProgress({ percent: 25, status: "loading" });

            const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
            const fontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
            const logoBytes = await fetch(Logo).then((res) => res.arrayBuffer());
            const pageWidth = 595;
            const pageHeight = 842;
            const margin = 50;
            const lineHeight = 12;

            // --- Cover Page ---

            const coverPage = pdfDoc.addPage([pageWidth, pageHeight]);
            const coverLabel = AISelectedApp?.summaryPmtLabel || "AttestaAI Report";
            const fontSize = 36;
            const textWidth = fontBold.widthOfTextAtSize(coverLabel, fontSize);
            coverPage.drawText(coverLabel, {
                x: (pageWidth - textWidth) / 2,
                y: pageHeight / 2,
                size: fontSize,
                font: fontBold,
            });

            // addWatermark(coverPage, "AttestaAI", fontBold, pageWidth, pageHeight);
            await addLogo(coverPage, pdfDoc, logoBytes, pageWidth);
            setPdfProgress({ percent: 35, status: "loading" });

            // --- Collect original pages to add ---

            let originalPages = [];
            if (reportType === "Duplicate") {
                for (const item of reportData) {
                    const p1 = parseInt(item.page_number, 10) - 1;
                    const p2 = parseInt(item.duplicate_page, 10) - 1;

                    if (!isNaN(p1) && p1 >= 0) originalPages.push(p1);
                    if (!isNaN(p2) && p2 >= 0) originalPages.push(p2);
                }
            } else if (reportType === "Missing") {
                const tempPages = [];
                for (const item of reportData) {
                    const start = parseInt(item.before_page, 10) - 1;
                    const end = parseInt(item.after_page, 10) - 1;

                    if (!isNaN(start) && !isNaN(end)) {
                        for (let i = start; i <= end; i++) {
                            tempPages.push(i);
                        }
                    }
                }
                originalPages = removeDuplicatesKeepOrder(tempPages);
            }

            setPdfProgress({ percent: 45, status: "loading" });

            // --- Table pages first ---

            let tablePage = pdfDoc.addPage([pageWidth, pageHeight]);
            addWatermark(tablePage, "AttestaAI", fontBold, pageWidth, pageHeight);
            await addLogo(tablePage, pdfDoc, logoBytes, pageWidth);

            let y = pageHeight - margin - 20;
            const colWidths = [...headers.map(() => 120), 50];
            const headersWithKeys = [...headers, { label: "page", key: "go" }];
            const drawHeaders = () => {
                let x = margin;
                headersWithKeys.forEach((header, idx) => {
                    tablePage.drawRectangle({
                        x,
                        y: y - 20,
                        width: colWidths[idx],
                        height: 20,
                        borderColor: rgb(0, 0, 0),
                        borderWidth: 1,
                    });
                    tablePage.drawText(header.label, {
                        x: x + 5,
                        y: y - 15,
                        size: 12,
                        font: fontBold,
                    });
                    x += colWidths[idx];
                });
                y -= 20;
            };
            drawHeaders();

            setPdfProgress({ percent: 55, status: "loading" });

            const maxRowsPerPage = 30;
            let rowCount = 0;
            const tablePages = [tablePage];
            const rowHeights = [];

            for (const item of reportData) {
                const linesPerColumn = headersWithKeys.map((header, idx) => {
                    if (header.key === "go") return [""];
                    const val = String(item[header.key] ?? "-");
                    return splitTextToLines(val, font, 10, colWidths[idx] - 10);
                });

                const rowHeightCurrent = Math.max(
                    ...linesPerColumn.map((l) => l.length * lineHeight + 4)
                );

                if (y - rowHeightCurrent < margin || rowCount >= maxRowsPerPage) {
                    tablePage = pdfDoc.addPage([pageWidth, pageHeight]);
                    tablePages.push(tablePage);
                    y = pageHeight - margin;
                    drawHeaders();
                    addWatermark(tablePage, "AttestaAI", fontBold, pageWidth, pageHeight);
                    await addLogo(tablePage, pdfDoc, logoBytes, pageWidth);
                    rowCount = 0;
                }

                let x = margin;
                headersWithKeys.forEach((header, idx) => {
                    const lines = linesPerColumn[idx];
                    tablePage.drawRectangle({
                        x,
                        y: y - rowHeightCurrent,
                        width: colWidths[idx],
                        height: rowHeightCurrent,
                        borderColor: rgb(0, 0, 0),
                        borderWidth: 1,
                    });

                    if (header.key !== "go") {
                        lines.forEach((line, lineIndex) => {
                            tablePage.drawText(line, {
                                x: x + 5,
                                y:
                                    y -
                                    rowHeightCurrent +
                                    rowHeightCurrent -
                                    (lineIndex + 1) * lineHeight -
                                    2,
                                size: 10,
                                font,
                            });
                        });
                    }

                    x += colWidths[idx];
                });

                rowHeights.push({ page: tablePage, y, height: rowHeightCurrent, item });
                y -= rowHeightCurrent;
                rowCount++;
            }

            setPdfProgress({ percent: 65, status: "loading" });

            // --- Add original pages ---
            const tableStartPageIndex = 1;
            const pageMap = new Map(); // Map<origIndex, number[]>

            for (const origIndex of originalPages) {
                const [copied] = await pdfDoc.copyPages(existingPdf, [origIndex]);
                const newPage = pdfDoc.addPage(copied);
                const newPageIndex = pdfDoc.getPageCount() - 1;

                if (!pageMap.has(origIndex)) {
                    pageMap.set(origIndex, []);
                }
                pageMap.get(origIndex).push(newPageIndex);

                // Number & navigation
                const pageNumberText = `${newPageIndex + 1}`;
                const textSize = 12;
                const textWidth = font.widthOfTextAtSize(pageNumberText, textSize);
                const textX = pageWidth - margin - textWidth - 20;
                const textY = margin - 5;

                newPage.drawText(pageNumberText, {
                    x: textX,
                    y: textY,
                    size: textSize,
                    font,
                    color: rgb(0, 0, 1),
                });

                const circleRadius = 10;
                const centerX = textX + textWidth + 15;
                const centerY = textY + 5;

                newPage.drawCircle({
                    x: centerX,
                    y: centerY,
                    size: circleRadius,
                    borderColor: rgb(0, 0, 1),
                    borderWidth: 1,
                });

                newPage.drawLine({
                    start: { x: centerX - 4, y: centerY - 2 },
                    end: { x: centerX, y: centerY + 3 },
                    color: rgb(0, 0, 1),
                    thickness: 1,
                });
                newPage.drawLine({
                    start: { x: centerX + 4, y: centerY - 2 },
                    end: { x: centerX, y: centerY + 3 },
                    color: rgb(0, 0, 1),
                    thickness: 1,
                });

                addPageLink(
                    pdfDoc,
                    newPage,
                    centerX - circleRadius,
                    centerY - circleRadius,
                    circleRadius * 2,
                    circleRadius * 2,
                    tableStartPageIndex
                );
            }

            setPdfProgress({ percent: 80, status: "loading" });

            // --- Render "Go" column with proper duplicate handling ---
            const occurrenceCounters = {}; // track duplicate use per targetPage

            rowHeights.forEach(({ page, y, height, item }) => {
                const goColX =
                    margin + colWidths.slice(0, headers.length).reduce((a, b) => a + b, 0);

                // let targetPage = parseInt(item.page_number, 10) - 1;
                let targetPage;
                if (reportType === "Duplicate")
                    targetPage = parseInt(item.page_number, 10) - 1;
                //   targetPage = parseInt(item.duplicate_page, 10) - 1;


                else if (reportType === "Missing")
                    targetPage = parseInt(item.before_page, 10) - 1;

                ;

                const occurrences = pageMap.get(targetPage) || [];
                if (!occurrenceCounters[targetPage]) {
                    occurrenceCounters[targetPage] = 0;
                }
                const useIndex = occurrenceCounters[targetPage]++;
                const displayPageIndex = occurrences[useIndex];

                const displayPage =
                    displayPageIndex !== undefined ? displayPageIndex + 1 : "-";

                const textY = y - height + height / 2 - 5;
                page.drawText(displayPage.toString(), {
                    x: goColX + 5,
                    y: textY,
                    size: 10,
                    font,
                    color: rgb(0, 0, 1),
                });

                const textWidth = font.widthOfTextAtSize(displayPage.toString(), 10);
                page.drawLine({
                    start: { x: goColX + 5, y: textY - 1 },
                    end: { x: goColX + 5 + textWidth, y: textY - 1 },
                    thickness: 0.5,
                    color: rgb(0, 0, 1),
                });

                if (displayPageIndex !== undefined) {
                    addPageLink(
                        pdfDoc,
                        page,
                        goColX,
                        y - height,
                        colWidths[colWidths.length - 1],
                        height,
                        displayPageIndex
                    );
                }
            });


            setPdfProgress({ percent: 90, status: "loading" });

            // --- Save & download ---
            const pdfBytes = await pdfDoc.save({
                useObjectStreams: true,
                addDefaultPage: false,
                compress: true,
            });

            const blob = new Blob([pdfBytes], { type: "application/pdf" });
            // const link = document.createElement("a");
            // link.href = URL.createObjectURL(blob);
            // link.download = "Report.pdf";
            // link.click();
            // Generate random 16-character alphanumeric string
            // const randomFileName = uuidv4()
            //     .replace(/-/g, "")
            //     .slice(0, 16)
            //     .toUpperCase();
            const randomFileName = `${randomPrefix()}${id}${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;


            const zip = new JSZip();
            zip.file(`${randomFileName}.pdf`, pdfBytes, { compression: "STORE" });

            const zipBlob = await zip.generateAsync({ type: "blob" });

            saveAs(zipBlob, `${randomFileName}.zip`);

            setPdfProgress({ percent: 100, status: "done" });

            setTimeout(() => {
                setPdfProgress({ percent: 0, status: "idle" });
            }, 1500);
        } catch (error) {
            console.error(error);
            setPdfProgress({ percent: 0, status: "error" });

            setTimeout(() => {
                setPdfProgress({ percent: 0, status: "idle" });
            }, 2000);
        }
    };






    console.log(headers)
    return (
        <div className="container mt-2">
            <Tooltip
                id="ai-summary-tooltip"
                className="tooltip-custom align-items-center"
            />

            <h3 className=" d-flex justify-content-between align-items-center w-100">
                <div
                    className="analysis-row"
                    data-tooltip-id="ai-summary-tooltip"
                    data-tooltip-content={
                        AISelectedApp?.summaryPmtLabel || "AttestaAI Summary"
                    }
                >
                    <div className="d-flex align-items-center">
                        <div className="custom-icon-wrapper">
                            <span
                                className="custom-icon attesta-blue"
                                dangerouslySetInnerHTML={{
                                    __html:
                                        AISelectedApp?.summaryPmtIcon ||
                                        '<i class="fa-solid fa-brain custom-icon"></i>',
                                }}
                            ></span>
                        </div>
                        <span className="ms-2 attesta-blue">
                            {AISelectedApp?.summaryPmtLabel || "AttestaAI Summary"}
                        </span>
                    </div>
                </div>
                {reportData.length > 0 &&
                    <div className="d-flex align-items-center ms-2 position-relative">
                        <Tooltip id="pdf-download-tooltip" className="tooltip-custom" />

                        {pdfProgress.status === "loading" ? (
                            <div
                                className={`position-relative ${pdfProgress.status === "error" ? "text-danger" : ""
                                    }`}
                                style={{ width: 40, height: 40, marginLeft: 2 }}
                            >
                                <CircularProgressbar
                                    value={
                                        pdfProgress.status === "error" ? 100 : pdfProgress.percent
                                    }
                                    strokeWidth={12}
                                    styles={buildStyles({
                                        pathColor:
                                            pdfProgress.status === "error" ? "#dc3545" : "rgb(22,112,140)",
                                        trailColor: "#eee",
                                        strokeLinecap: "round",
                                        pathTransitionDuration: 0.5,
                                    })}
                                />
                                <div
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        fontSize: "10px",
                                        fontWeight: "bold",
                                        color: pdfProgress.status === "error" ? "#dc3545" : "rgb(22,112,140)",
                                        pointerEvents: "none",
                                        userSelect: "none",
                                    }}
                                >
                                    {pdfProgress.status === "error"
                                        ? "✕"
                                        : `${pdfProgress.percent}%`}
                                </div>
                            </div>
                        ) : (

                            <button
                                type="button"
                                className="btn common-btn p-1 border-0"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    downloadPDF();
                                }}
                                data-tooltip-id="pdf-download-tooltip"
                                data-tooltip-content={`${AISelectedApp?.summaryPmtLabel || "AttestaAI Summary"
                                    } Download PDF`}
                            >
                                <img
                                    src={pdfImg}
                                    alt="PDF Icon"
                                    style={{ width: "18px", height: "22px" }}
                                />
                            </button>
                        )}
                    </div>
                }
            </h3>
            <div
                style={{
                    minHeight: "250px",
                    maxHeight: "calc(-250px + 100vh)",
                    overflowY: "auto",
                }}
            >
                <Table hover>
                    <thead className="custom-header-border">
                        <tr>
                            {headers.map((header, index) => (
                                <th key={index}>{header.label}</th>
                            ))}
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentItems.length > 0 ? (
                            currentItems.map((item, index) => (
                                <tr key={index} className="custom-row-border">
                                    {headers.map((header, idx) => (
                                        <td key={idx}>{item[header.key] ?? "-"}</td>
                                    ))}
                                    <td>
                                        <Button
                                            variant="light"
                                            size="sm"
                                            className="download-btn attesta-blue"
                                            onClick={() => handleViewClick(item)}
                                        >
                                            <i className="fa-regular fa-eye"></i> View
                                        </Button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" className="text-center text-muted py-3">
                                    No report available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>

            {totalPages > 1 && (
                <Pagination className="custom-pagination justify-content-end mt-2">
                    <Pagination.First
                        onClick={fastBackward}
                        disabled={currentPage === 1}
                    />
                    <Pagination.Prev
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    />
                    {pageNumbers
                        .slice(
                            Math.max(0, currentPage - 3),
                            Math.min(totalPages, currentPage + 2)
                        )
                        .map((number) => (
                            <Pagination.Item
                                key={number}
                                active={number === currentPage}
                                onClick={() => paginate(number)}
                            >
                                {number}
                            </Pagination.Item>
                        ))}
                    <Pagination.Next
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    />
                    <Pagination.Last
                        onClick={fastForward}
                        disabled={currentPage === totalPages}
                    />
                </Pagination>
            )}

            {/* <PDFCanvasViewer
                pageRange={'1'}
                scale={1.5}
                selectedpdf={pdf}
            /> */}
            {showModal && (
                <div className="duplicate-modal-overlay">
                    <div className="duplicate-modal">
                        <div className="duplicate-modal-header">
                            <h5 className="duplicate-modal-title">Duplicate Page Comparison</h5>
                            <button
                                className="duplicate-modal-close"
                                onClick={() => {
                                    setShowModal(false);
                                    setselectedItem(null);
                                }}
                            >
                                ✖
                            </button>
                        </div>

                        <div className="duplicate-modal-body">
                            <div className="duplicate-half me-1">
                                <h3 className="text-center mb-2 mt-2">Original Page</h3>
                                <PDFCanvasViewer
                                    pageRange={pageRange.pageRange1}
                                    scale={1.5}
                                    selectedpdf={pdfToPreview}
                                />

                            </div>

                            <div className="duplicate-half ms-1">
                                <h3 className="text-center mb-2 mt-2">
                                    Duplicate Page - {selectedItem?.similarity} Similarity
                                </h3>

                                <PDFCanvasViewer
                                    pageRange={pageRange.pageRange2}
                                    scale={1.5}
                                    selectedpdf={pdfToPreview}
                                />


                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MissingorDuplicateReport;

